import Constant from './Constant';
import ItemStatusColor from './ItemStatusColor';
import TelephoneConstant from './TelephoneConstant';

export const TmpHiddenSystemField = [
    'guestOrg',
    'guestProject',
    'adminMailAdress',
    'adminLastName',
    'adminFirstName',
    'category',
    'description',
    'customerEmail',
    'customerLastName',
    'customerFirstName',
   // 'field_qa_category',
    'priority',
    'knowledgeCanvas',
    'bookmark',
    'deadline',
    'point',
    'footPrint',
    'maxGeneralId',
    'pageNo',
    'chapter',
    'section',
    'subSection',
    'item',
    'from',
    'to',
    'cc',
    'bcc',
    'mailSubject',
    'mailBody',
    'field_business_app_name',
    'field_business_app_page',
    'telephone_start_time',
    'telephone_end_time',
    'telephone_duration',
    'telephone_call_recording_url',
    'telephone_transcript_url',
    'telephone_ai_call_summary',
    'telephone_human_memo',
    'telephone_ai_score',
    'telephone_ai_evaluation',
    'telephone_human_score',
    'telephone_human_evaluation',
    'telephone_ai_operator_prompt',
    'telephone_related_tickets',
    'telephone_next_call',
    'telephone_child_link',
    'telephone_caller_language',    // Removed by migrate290183
    'telephone_receiver_language',  // Removed by migrate290183
]

export const ForceActiveSystemFields = [
    'attachments', 
    'ticketId',
    'ticketType',	
    'footPrint',
    'proxiedUser',
    'parent',
    'children',
    'escalationOriginCustomer',
    'escalationTarget',
    'personInCharge', 
    'AIPromptBody',
    'ApplyAIprompt',
    'AIPromptApplicationTarget',
    'listOfSynonyms',
    'from',
    'to',
    'cc',
    'bcc',
    'mailSubject',
    'mailBody',
    'AIBasicInfoTransmission',
    'ai_pdf_page_split_status',
    'ai_telephone_operator_name',
    'ai_telephone_realtime_model',
    'ai_telephone_greeting',
    'ai_telephone_trigger_condition',
    'ai_telephone_receiving_call_execution_mode',
    'ai_telephone_time_based_delay_response',
    'ai_telephone_receiving_call_execution_time_period',
    'ai_telephone_receiving_call_execution_start_time',
    'ai_telephone_receiving_call_execution_end_time',
    'ai_telephone_receiving_call_execution_start_date',
    'ai_telephone_receiving_call_execution_end_date',
    'ai_telephone_receiving_call_execution_day_of_weeks',
    'ai_telephone_applicable_phone_number',
    'ai_telephone_execution_scope',
    'ai_telephone_voice_settings',
    'telephone_follow_up_status',
    'telephone_review_status',
    'telephone_evaluator',
]

export const TmpHiddenSysFieldInTicketDetail = [
    'ticketId',
    'ticketType',	
    'footPrint',
    'proxiedUser',
    'children',
    'parent'
    // 'escalationOriginCustomer',
    // 'escalationTarget',
    // 'personInCharge',
    // 'field_qa_category' 
]

export const TmpHiddenSysfieldInCreateTicket = [
    'ticketId',
    'ticketType',	
    'footPrint',
    'proxiedUser',
    'parent',
    'children',
    'escalationOriginCustomer',
    'escalationTarget',
    'personInCharge',
    // 'field_qa_category' ,
    'pageNo',
    'chapter',
    'section',
    'subSection',
    'item',
    'from',
]

export const HasExpandSysField = [
    'attachments',
    'ticketId',
    'personInCharge',
    'proxiedUser',
    'outline',
    'ticketType',	
    'footPrint',
    'parent',
    'children',
    'escalationOriginCustomer',
    'escalationTarget',
    'AIPromptBody',
    'ApplyAIprompt',
    'AIPromptApplicationTarget',
    'listOfSynonyms'
]

export const AutoPassSystemFieldInSchema = [
    'escalationOriginCustomer',
    'escalationTarget',
    'from',
    'to',
    'telephone_start_time',
    'telephone_end_time'
]

export const PageSystemFields = [
    'pageNo',
    'chapter',
    'section',
    'subSection',
    'item',
]

export const AISystemField = [
    'AIPromptBody',
    'ApplyAIprompt',
    'AIPromptApplicationTarget',
    'ai_telephone_greeting',
    'field_kibana_analysis'
]

export const IgnoreIndexSystemTagField = [
    'field_tag_and_ai_auto',
    'field_tag_or_ai_auto',
    'field_tag_exclude_ai_auto'
]

export const IgnoreBulkActionField = [
    'field_ticket_type_active_ai_auto',
    'field_form_active_ai_auto',
    'field_tag_and_ai_auto',
    'field_tag_or_ai_auto',
    'field_tag_exclude_ai_auto',
    'field_mcp_server_setting',
    Constant.SYSTEM_FIELD.CHATGPT_MODEL,
    Constant.SYSTEM_FIELD.REASONING_EFFORT,
    Constant.SYSTEM_FIELD.AI_TELEPHONE_TRIGGER_CONDITION,
    Constant.SYSTEM_FIELD.AI_TELEPHONE_RECEIVING_CALL_EXECUTION_MODE,
    Constant.SYSTEM_FIELD.AI_TELEPHONE_RECEIVING_CALL_EXECUTION_TIME_PERIOD,
    Constant.SYSTEM_FIELD.AI_TELEPHONE_RECEIVING_CALL_EXECUTION_DAY_OF_WEEKS,
    Constant.SYSTEM_FIELD.AI_TELEPHONE_APPLICABLE_PHONE_NUMBER,
    Constant.SYSTEM_FIELD.AI_TELEPHONE_EXECUTION_SCOPE,
    // Telephone fields - cannot be bulk edited
    TelephoneConstant.TELEPHONE.SYSTEM_FIELD.CALL_TYPE,
    TelephoneConstant.TELEPHONE.SYSTEM_FIELD.CALLER_LANGUAGE,
    TelephoneConstant.TELEPHONE.SYSTEM_FIELD.RECEIVER_LANGUAGE,
    TelephoneConstant.TELEPHONE.SYSTEM_FIELD.CALL_MODE,
    TelephoneConstant.TELEPHONE.SYSTEM_FIELD.CALL_HANDLER,
    TelephoneConstant.TELEPHONE.SYSTEM_FIELD.EVALUATOR,
    TelephoneConstant.TELEPHONE.SYSTEM_FIELD.AI_OPERATOR_PROMPT,
];

export const AutoPassForBulkAction = [
    'ApplyAIprompt',
    'field_kibana_analysis',
    'field_event_trigger_ai_auto',
    'field_event_type_chat_thread',
    'field_hours_execute_ai_auto',
    'field_minutes_execute_ai_auto',
    'AIPromptApplicationTarget',
    'AIBasicInfoTransmission',
    'ai_pdf_page_split_status',
    TelephoneConstant.TELEPHONE.SYSTEM_FIELD.REVIEW_STATUS
];

export const TELEPHONE_FIELD_ORDER = [
    'telephone_call_status',           // 1 - User can view status
    'telephone_call_type',             // 3 - User selectable
    'telephone_call_mode',             // 4 - User selectable
    'telephone_from',                  // 5 - User input
    'telephone_to',                    // 6 - User input
    'telephone_call_handler',          // 7 - User selectable
    // 'telephone_caller_language',    // [REMOVED] 9 - Removed by migrate290183
    // 'telephone_receiver_language',  // [REMOVED] 10 - Removed by migrate290183
    'telephone_follow_up_status',      // 18 - NEW - User selectable
    'telephone_review_status',         // 21 - NEW - User selectable
    'telephone_evaluator',             // 22 - User selectable
];

export const systemField = [
    {
        id: 'guestOrg',
        usage: Constant.FORM_USAGE.FIELD,
        name: {
            jp: {
                A: 'F',
                text: '推薦ゲスト組織',
            },
        },
        type: Constant.FORM_TYPE.FIELD_TEXT,
        structure: {
            UI: Constant.FIELD_UI.TEXT,
            elasticSearch: '',
            required: true,
        },
        definition: Constant.FORM_DEFINITION.SYSTEM,
        sysfield: 'guestOrg',
        noInFormInvite: 1,
    },
    {
        id: 'guestProject',
        usage: Constant.FORM_USAGE.FIELD,
        name: {
            jp: {
                A: 'F',
                text: '推薦パートナープロジェクト',
            },
        },
        type: Constant.FORM_TYPE.FIELD_TEXT,
        structure: {
            UI: Constant.FIELD_UI.TEXT,
            elasticSearch: '',
            required: true,
        },
        definition: Constant.FORM_DEFINITION.SYSTEM,
        sysfield: 'guestProject',
        noInFormInvite: 2,
    },
    {
        id: 'adminMailAdress',
        usage: Constant.FORM_USAGE.FIELD,
        name: {
            jp: {
                A: 'F',
                text: '代表者アドレス',
            },
        },
        type: Constant.FORM_TYPE.FIELD_TEXT,
        structure: {
            UI: Constant.FIELD_UI.TEXT,
            elasticSearch: '',
            required: true,
            regExpr: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
        },
        definition: Constant.FORM_DEFINITION.SYSTEM,
        sysfield: 'adminMailAdress',
        noInFormInvite: 3,
    },
    {
        id: 'adminLastName',
        usage: Constant.FORM_USAGE.FIELD,
        name: {
            jp: {
                A: 'F',
                text: '代表者姓',
            },
        },
        type: Constant.FORM_TYPE.FIELD_TEXT,
        structure: {
            UI: Constant.FIELD_UI.TEXT,
            elasticSearch: '',
            required: true
        },
        definition: Constant.FORM_DEFINITION.SYSTEM,
        sysfield: 'adminLastName',
        noInFormInvite: 4,
    },
    {
        id: 'adminFirstName',
        usage: Constant.FORM_USAGE.FIELD,
        name: {
            jp: {
                A: 'F',
                text: '代表者名',
            },
        },
        type: Constant.FORM_TYPE.FIELD_TEXT,
        structure: {
            UI: Constant.FIELD_UI.TEXT,
            elasticSearch: '',
            required: true
        },
        definition: Constant.FORM_DEFINITION.SYSTEM,
        sysfield: 'adminFirstName',
        noInFormInvite: 5,
    },
    {
        id: 'outline',
        usage: Constant.FORM_USAGE.FIELD,
        name: {
            jp: {
                A: 'F',
                text: '概要',
            },
        },
        type: Constant.FORM_TYPE.FIELD_TEXT,
        structure: {
            UI: Constant.FIELD_UI.TEXT,
            elasticSearch: '',
            maxLength: 2000,
        },
        definition: Constant.FORM_DEFINITION.SYSTEM,
        sysfield: 'outline',
        // noInFormInvite: 6,
        noInFormQA: 1,
        noInFormExternalDeskRequest: 1,
        noInFormGuestCustomerInvitation: 4,
        noInFormExternalCustomerRequest: 1,
        noInFormFileFormat: 3,
        noInFormPageFormat: 3,
        noInFormAIChatPrompt: 1,
        noInFormAITelephonePrompt: 1,
        noInFormAIAssistantPrompt: 1,
        noInFormAITrainingPrompt: 1,
    },
    {
        id: 'category',
        usage: Constant.FORM_USAGE.FIELD,
        name: {
            jp: {
                A: 'F',
                text: 'カテゴリー',
            },
        },
        type: Constant.FORM_TYPE.FIELD_TEXT,
        structure: {
            UI: Constant.FIELD_UI.TEXT,
            elasticSearch: '',
            maxLength: 50
        },
        definition: Constant.FORM_DEFINITION.SYSTEM,
        sysfield: 'category',
        // noInFormInvite: 7,
        noInFormExternalDeskRequest: 2,
        noInFormGuestCustomerInvitation: 5,
        noInFormExternalCustomerRequest: 2,
    },
    {
        id: 'description',
        usage: Constant.FORM_USAGE.FIELD,
        name: {
            jp: {
                A: 'F',
                text: '詳細',
            },
        },
        type: Constant.FORM_TYPE.FIELD_TEXT,
        structure: {
            UI: Constant.FIELD_UI.TEXT_AREA,
            elasticSearch: '',
            maxLength: 2000
        },
        definition: Constant.FORM_DEFINITION.SYSTEM,
        sysfield: 'description',
        // noInFormInvite: 8,
        noInFormQA: 3,
        noInFormExternalDeskRequest: 3,
        noInFormGuestCustomerInvitation: 6,
        noInFormExternalCustomerRequest: 3,
        noInFormAITelephonePrompt: 5,
    },
    {
        id: 'attachments',
        usage: Constant.FORM_USAGE.FIELD,
        name: {
            jp: {
                A: 'F',
                text: '添付ファイル',
            },
        },
        type: Constant.FORM_TYPE.FIELD_TEXT,
        structure: {
            UI: Constant.FIELD_UI.DROP_FILE,
            elasticSearch: '',
        },
        definition: Constant.FORM_DEFINITION.SYSTEM,
        sysfield: 'attachments',
        // noInFormInvite: 9,
        noInFormQA: 4,
        noInFormGuestCustomerInvitation: 7,
        noInFormFileFormat: 5,
        noInFormPageFormat: 9,
        noInFormEmail: 8
    },

    // QA form area
    // QA tag field category
    {
        id: 'field_qa_category',
        usage: Constant.FORM_USAGE.FIELD,
        name: {
            jp: {
                A: 'F',
                text: '問い合わせカテゴリー',
            },
        },
        type: Constant.FORM_TYPE.FIELD_TAG,
        structure: {
            UI: Constant.FIELD_UI.TAG,
            isMultiple: false,
            optionType: Constant.TAG_FIELD_DEFAULT.SELECT_OPTION_TYPE,
            recordNumber: Constant.TAG_FIELD_DEFAULT.RECORD_NUMBER,
            isAddItem: false,
            settingSelectItem: Constant.SETTING_SELECT_ITEM_TAG_FIELD.DEFAULT,
            displayOrder: Constant.DISPLAY_ORDER_TAG_FIELD.DEFAULT,
            elasticSearch: '',
            required: true,
        },
        definition: Constant.FORM_DEFINITION.SYSTEM,
        sysfield: 'field_qa_category',
        noInFormQA: 2,
    },

    // QA tag item field category
    {
        id: 'field_qa_category_tag_requirement',
        usage: Constant.FORM_USAGE.TAG,
        name: {
            jp: {
                A: 'F',
                text: '商品仕様',
            },
        },
        affiliationField: 'field_qa_category',
        type: '',
        structure: {
            isShowItemInTicket: true,
            no: 1,
        },
        viewForCustomer: {},
        definition: Constant.FORM_DEFINITION.SYSTEM,
        sysfield: 'field_qa_category_tag_requirement',
    },
    {
        id: 'field_qa_category_tag_price',
        usage: Constant.FORM_USAGE.TAG,
        name: {
            jp: {
                A: 'F',
                text: '価格',
            },
        },
        affiliationField: 'field_qa_category',
        type: '',
        structure: {
            isShowItemInTicket: true,
            no: 2,
        },
        viewForCustomer: {},
        definition: Constant.FORM_DEFINITION.SYSTEM,
        sysfield: 'field_qa_category_tag_price',
    },
    {
        id: 'field_qa_category_tag_quotation',
        usage: Constant.FORM_USAGE.TAG,
        name: {
            jp: {
                A: 'F',
                text: '見積依頼',
            },
        },
        affiliationField: 'field_qa_category',
        type: '',
        structure: {
            isShowItemInTicket: true,
            no: 3,
        },
        viewForCustomer: {},
        definition: Constant.FORM_DEFINITION.SYSTEM,
        sysfield: 'field_qa_category_tag_quotation',
    },
    {
        id: 'field_qa_category_tag_cancel',
        usage: Constant.FORM_USAGE.TAG,
        name: {
            jp: {
                A: 'F',
                text: 'キャンセル',
            },
        },
        affiliationField: 'field_qa_category',
        type: '',
        structure: {
            isShowItemInTicket: true,
            no: 4,
        },
        viewForCustomer: {},
        definition: Constant.FORM_DEFINITION.SYSTEM,
        sysfield: 'field_qa_category_tag_cancel',
    },
    {
        id: 'field_qa_category_tag_shipping_delivery',
        usage: Constant.FORM_USAGE.TAG,
        name: {
            jp: {
                A: 'F',
                text: '送料＆配送',
            },
        },
        affiliationField: 'field_qa_category',
        type: '',
        structure: {
            isShowItemInTicket: true,
            no: 5,
        },
        viewForCustomer: {},
        definition: Constant.FORM_DEFINITION.SYSTEM,
        sysfield: 'field_qa_category_tag_shipping_delivery',
    },
    {
        id: 'field_qa_category_tag_payment',
        usage: Constant.FORM_USAGE.TAG,
        name: {
            jp: {
                A: 'F',
                text: '支払い',
            },
        },
        affiliationField: 'field_qa_category',
        type: '',
        structure: {
            isShowItemInTicket: true,
            no: 6,
        },
        viewForCustomer: {},
        definition: Constant.FORM_DEFINITION.SYSTEM,
        sysfield: 'field_qa_category_tag_payment',
    },
    {
        id: 'field_qa_category_tag_business_day',
        usage: Constant.FORM_USAGE.TAG,
        name: {
            jp: {
                A: 'F',
                text: '営業日',
            },
        },
        affiliationField: 'field_qa_category',
        type: '',
        structure: {
            isShowItemInTicket: true,
            no: 7,
        },
        viewForCustomer: {},
        definition: Constant.FORM_DEFINITION.SYSTEM,
        sysfield: 'field_qa_category_tag_business_day',
    },
    {
        id: 'field_qa_category_tag_operation_setting_method',
        usage: Constant.FORM_USAGE.TAG,
        name: {
            jp: {
                A: 'F',
                text: '操作＆設定方法',
            },
        },
        affiliationField: 'field_qa_category',
        type: '',
        structure: {
            isShowItemInTicket: true,
            no: 8,
        },
        viewForCustomer: {},
        definition: Constant.FORM_DEFINITION.SYSTEM,
        sysfield: 'field_qa_category_tag_operation_setting_method',
    },
    {
        id: 'field_qa_category_tag_troubleshooting',
        usage: Constant.FORM_USAGE.TAG,
        name: {
            jp: {
                A: 'F',
                text: 'トラブル対応',
            },
        },
        affiliationField: 'field_qa_category',
        type: '',
        structure: {
            isShowItemInTicket: true,
            no: 9,
        },
        viewForCustomer: {},
        definition: Constant.FORM_DEFINITION.SYSTEM,
        sysfield: 'field_qa_category_tag_troubleshooting',
    },
    {
        id: 'field_qa_category_tag_order',
        usage: Constant.FORM_USAGE.TAG,
        name: {
            jp: {
                A: 'F',
                text: '注文',
            },
        },
        affiliationField: 'field_qa_category',
        type: '',
        structure: {
            isShowItemInTicket: true,
            no: 10,
        },
        viewForCustomer: {},
        definition: Constant.FORM_DEFINITION.SYSTEM,
        sysfield: 'field_qa_category_tag_order',
    },
    {
        id: 'field_qa_category_tag_document_request',
        usage: Constant.FORM_USAGE.TAG,
        name: {
            jp: {
                A: 'F',
                text: '資料希望',
            },
        },
        affiliationField: 'field_qa_category',
        type: '',
        structure: {
            isShowItemInTicket: true,
            no: 11,
        },
        viewForCustomer: {},
        definition: Constant.FORM_DEFINITION.SYSTEM,
        sysfield: 'field_qa_category_tag_document_request',
    },
    {
        id: 'field_qa_category_tag_document_others',
        usage: Constant.FORM_USAGE.TAG,
        name: {
            jp: {
                A: 'F',
                text: 'その他',
            },
        },
        affiliationField: 'field_qa_category',
        type: '',
        structure: {
            isShowItemInTicket: true,
            no: 12,
        },
        viewForCustomer: {},
        definition: Constant.FORM_DEFINITION.SYSTEM,
        sysfield: 'field_qa_category_tag_document_others',
    },

    // field status as new project created
    // {
    //     id: 'field_status',
    //     usage: Constant.FORM_USAGE.FIELD,
    //     name: {
    //         jp: {
    //             A: 'F',
    //             text: 'ステータス',
    //         },
    //     },
    //     type: Constant.FORM_TYPE.FIELD_WORKFLOW,
    //     structure: {
    //         UI: Constant.FIELD_UI.SELECTOR,
    //         elasticSearch: '',
    //         workFlow: false,
    //     },
    //     definition: Constant.FORM_DEFINITION.SYSTEM,
    //     sysfield: 'field_status',
    //     noInFieldStatus: 0,
    // noInFormEmail: 2
    // },

    // items of field status
    {
        id: 'field_status_waiting',
        usage: Constant.FORM_USAGE.STATUS,
        name: {
            jp: {
                A: 'F',
                text: 'WAITING',
            },
        },
        affiliationField: 'field_status',
        type: '',
        structure: {
            helpdesk: {
                color: ItemStatusColor[0].color,
                background: ItemStatusColor[0].background,
            },
            customer: {
                color: ItemStatusColor[0].color,
                background: ItemStatusColor[0].background,
            },
            no: 1,
            isUsingItem: true,
        },
        viewForCustomer: {
            jp: {
                A: 'F',
                text: 'WAITING',
            },
        },
        definition: Constant.FORM_DEFINITION.SYSTEM,
        sysfield: 'field_status_waiting',
        noInFieldStatus: 1,
    },
    {
        id: 'field_status_todo',
        usage: Constant.FORM_USAGE.STATUS,
        name: {
            jp: {
                A: 'F',
                text: 'TODO',
            },
        },
        affiliationField: 'field_status',
        type: '',
        structure: {
            helpdesk: {
                color: ItemStatusColor[0].color,
                background: ItemStatusColor[0].background,
            },
            customer: {
                color: ItemStatusColor[0].color,
                background: ItemStatusColor[0].background,
            },
            no: 2,
            isUsingItem: true,
        },
        viewForCustomer: {
            jp: {
                A: 'F',
                text: 'TODO',
            },
        },
        definition: Constant.FORM_DEFINITION.SYSTEM,
        sysfield: 'field_status_todo',
        noInFieldStatus: 2,
    },
    {
        id: 'field_status_doing',
        usage: Constant.FORM_USAGE.STATUS,
        name: {
            jp: {
                A: 'F',
                text: 'DOING',
            },
        },
        affiliationField: 'field_status',
        type: '',
        structure: {
            helpdesk: {
                color: ItemStatusColor[0].color,
                background: ItemStatusColor[0].background,
            },
            customer: {
                color: ItemStatusColor[0].color,
                background: ItemStatusColor[0].background,
            },
            no: 3,
            isUsingItem: true,
        },
        viewForCustomer: {
            jp: {
                A: 'F',
                text: 'DOING',
            },
        },
        definition: Constant.FORM_DEFINITION.SYSTEM,
        sysfield: 'field_status_doing',
        noInFieldStatus: 3,
    },
    {
        id: 'field_status_done',
        usage: Constant.FORM_USAGE.STATUS,
        name: {
            jp: {
                A: 'F',
                text: 'DONE',
            },
        },
        affiliationField: 'field_status',
        type: '',
        structure: {
            helpdesk: {
                color: ItemStatusColor[0].color,
                background: ItemStatusColor[0].background,
            },
            customer: {
                color: ItemStatusColor[0].color,
                background: ItemStatusColor[0].background,
            },
            no: 4,
            isUsingItem: true,
        },
        viewForCustomer: {
            jp: {
                A: 'F',
                text: 'DONE',
            },
        },
        definition: Constant.FORM_DEFINITION.SYSTEM,
        sysfield: 'field_status_done',
        noInFieldStatus: 4,
    },
    {
        id: 'field_status_pending',
        usage: Constant.FORM_USAGE.STATUS, 
        name: {
            jp: {
                A: 'F',
                text: 'PENDING',
            },
        },
        affiliationField: 'field_status',
        type: '',
        structure: {
            helpdesk: {
                color: ItemStatusColor[0].color,
                background: ItemStatusColor[0].background,
            },
            customer: {
                color: ItemStatusColor[0].color,
                background: ItemStatusColor[0].background,
            },
            no: 5,
            isUsingItem: true,
        },
        viewForCustomer: {
            jp: {
                A: 'F',
                text: 'PENDING',
            },
        },
        definition: Constant.FORM_DEFINITION.SYSTEM,
        sysfield: 'field_status_pending',
        noInFieldStatus: 5,
    },


    // Field system form guest customer invitation
    {
        id: 'customerEmail',
        usage: Constant.FORM_USAGE.FIELD,
        name: {
            jp: {
                A: 'F',
                text: '登録カスタマーアドレス',
            },
        },
        type: Constant.FORM_TYPE.FIELD_TEXT,
        structure: {
            UI: Constant.FIELD_UI.TEXT,
            elasticSearch: '',
            required: true,
            regExpr: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
        },
        definition: Constant.FORM_DEFINITION.SYSTEM,
        sysfield: 'customerEmail',
        noInFormGuestCustomerInvitation: 1,
    },
    {
        id: 'customerLastName',
        usage: Constant.FORM_USAGE.FIELD,
        name: {
            jp: {
                A: 'F',
                text: 'カスタマー姓',
            },
        },
        type: Constant.FORM_TYPE.FIELD_TEXT,
        structure: {
            UI: Constant.FIELD_UI.TEXT,
            elasticSearch: '',
        },
        definition: Constant.FORM_DEFINITION.SYSTEM,
        sysfield: 'customerLastName',
        noInFormGuestCustomerInvitation: 2,
    },
    {
        id: 'customerFirstName',
        usage: Constant.FORM_USAGE.FIELD,
        name: {
            jp: {
                A: 'F',
                text: 'カスタマー名',
            },
        },
        type: Constant.FORM_TYPE.FIELD_TEXT,
        structure: {
            UI: Constant.FIELD_UI.TEXT,
            elasticSearch: '',
        },
        definition: Constant.FORM_DEFINITION.SYSTEM,
        sysfield: 'customerFirstName',
        noInFormGuestCustomerInvitation: 3,
    },

    // New systemField
    {
        usage: Constant.FORM_USAGE.FIELD,
        name: {
            jp: {
                A: 'F',
                text: 'チケットID',
            },
        },
        type: Constant.FORM_TYPE.FIELD_TEXT,
        structure: {
            UI: Constant.FIELD_UI.TEXT,
            elasticSearch: '',
            isAutoAddData: 'true',
            isAutoFill: 'true',
            required: true,
            disableSettingRequired: true,
            publicForCustomer: Constant.SETTING_FORM_DEFAULT.READ_ONLY,
            disablePublicForCustomer: true,
        },
        definition: Constant.FORM_DEFINITION.SYSTEM,
        sysfield: 'ticketId',
        id: 'ticketId',
        noInFormQA: 9,
        noInFormFileFormat: 1,
        noInFormPageFormat: 1,
    },
    {
        usage: Constant.FORM_USAGE.FIELD,
        name: {
            jp: {
                A: 'F',
                text: 'チケットタイプ',
            },
        },
        type: Constant.FORM_TYPE.FIELD_TEXT,
        structure: {
            UI: Constant.FIELD_UI.TEXT,
            elasticSearch: '',
            isAutoAddData: 'true',
            isAutoFill: 'true',
            required: true,
            disableSettingRequired: true,
            publicForCustomer: Constant.SETTING_FORM_DEFAULT.DO_NOT_SHOW,
            disablePublicForCustomer: true,
        },
        definition: Constant.FORM_DEFINITION.SYSTEM,
        sysfield: 'ticketType',
        id: 'ticketType',
        noInFormQA: 10,
        noInFormFileFormat: 2,
        noInFormPageFormat: 2
    },
    {
        usage: Constant.FORM_USAGE.FIELD,
        name: {
            jp: {
                A: 'F',
                text: '足跡',
            },
        },
        type: Constant.FORM_TYPE.FIELD_TEXT,
        structure: {
            UI: Constant.FIELD_UI.TEXT,
            elasticSearch: '',
            isAutoAddData: 'true',
            isAutoFill: 'true'
        },
        definition: Constant.FORM_DEFINITION.SYSTEM,
        sysfield: 'footPrint',
        id: 'footPrint',
        
    },
    {
        usage: Constant.FORM_USAGE.FIELD,
        name: {
            jp: {
                A: 'F',
                text: '代理投稿者',
            },
        },
        type: Constant.FORM_TYPE.FIELD_TEXT,
        structure: {
            UI: Constant.FIELD_UI.TEXT,
            elasticSearch: '',
            isAutoAddData: 'true',
            isAutoFill: 'true',
            required: true,
            disableSettingRequired: true,
        },
        definition: Constant.FORM_DEFINITION.SYSTEM,
        sysfield: 'proxiedUser',
        id: 'proxiedUser',
        noInFormQA: 7
    },
    {
        usage: Constant.FORM_USAGE.FIELD,
        name: {
            jp: {
                A: 'F',
                text: '親チケット',
            },
        },
        type: Constant.FORM_TYPE.FIELD_TEXT,
        structure: {
            UI: Constant.FIELD_UI.TEXT,
            elasticSearch: '',
            isAutoAddData: 'true',
            isAutoFill: 'true',
            required: true,
            disableSettingRequired: true,
            publicForCustomer: Constant.SETTING_FORM_DEFAULT.DO_NOT_SHOW,
            disablePublicForCustomer: true,
        },
        definition: Constant.FORM_DEFINITION.SYSTEM,
        sysfield: 'parent',
        id: 'parent',
        noInFormQA: 12,
        noInFormFileFormat: 6,
        noInFormPageFormat: 10
    },
    {
        usage: Constant.FORM_USAGE.FIELD,
        name: {
            jp: {
                A: 'F',
                text: '子チケット',
            },
        },
        type: Constant.FORM_TYPE.FIELD_TEXT,
        structure: {
            UI: Constant.FIELD_UI.TEXT,
            elasticSearch: '',
            isAutoAddData: 'true',
            isAutoFill: 'true',
            required: true,
            disableSettingRequired: true,
            publicForCustomer: Constant.SETTING_FORM_DEFAULT.DO_NOT_SHOW,
            disablePublicForCustomer: true,
        },
        definition: Constant.FORM_DEFINITION.SYSTEM,
        sysfield: 'children',
        id: 'children',
        noInFormQA: 8,
        noInFormFileFormat: 7,
        noInFormPageFormat: 11
    },
    {
        usage: Constant.FORM_USAGE.FIELD,
        name: {
            jp: {
                A: 'F',
                text: 'エスカレーション元のカスタマー',
            },
        },
        type: Constant.FORM_TYPE.FIELD_TEXT,
        structure: {
            UI: Constant.FIELD_UI.TEXT,
            elasticSearch: '',
            isAutoAddData: 'true',
            isAutoFill: 'true',
            required: true,
            disableSettingRequired: true,
            publicForCustomer: Constant.SETTING_FORM_DEFAULT.READ_ONLY,
            disablePublicForCustomer: true,
        },
        definition: Constant.FORM_DEFINITION.SYSTEM,
        sysfield: 'escalationOriginCustomer',
        id: 'escalationOriginCustomer',
        noInFormQA: 11
    },
    {
        usage: Constant.FORM_USAGE.FIELD,
        name: {
            jp: {
                A: 'F',
                text: 'エスカレーション先',
            },
        },
        type: Constant.FORM_TYPE.FIELD_TEXT,
        structure: {
            UI: Constant.FIELD_UI.TEXT,
            elasticSearch: '',
            isAutoAddData: 'true',
            isAutoFill: 'true',
            required: true,
            disableSettingRequired: true,
            publicForCustomer: Constant.SETTING_FORM_DEFAULT.DO_NOT_SHOW,
            disablePublicForCustomer: true,
        },
        definition: Constant.FORM_DEFINITION.SYSTEM,
        sysfield: 'escalationTarget',
        id: 'escalationTarget',
        noInFormQA: 5
    },
    {
        usage: Constant.FORM_USAGE.FIELD,
        name: {
            jp: {
                A: 'F',
                text: '担当者',
            },
        },
        type: Constant.FORM_TYPE.FIELD_TEXT,
        structure: {
            UI: Constant.FIELD_UI.TEXT,
            elasticSearch: '',
            disableSettingRequired: true,
        },
        definition: Constant.FORM_DEFINITION.SYSTEM,
        sysfield: 'personInCharge',
        id: 'personInCharge',
        noInFormQA: 6,
        noInFormEmail: 1,
    },


    {
        usage: Constant.FORM_USAGE.FIELD,
        name: {
            jp: {
                A: 'F',
                text: '案件緊急度',
            },
        },
        type: Constant.FORM_TYPE.FIELD_TEXT,
        structure: {
            UI: Constant.FIELD_UI.TEXT,
            elasticSearch: '',
        },
        definition: Constant.FORM_DEFINITION.SYSTEM,
        sysfield: 'priority',
        id: 'priority',
    },
    {
        usage: Constant.FORM_USAGE.FIELD,
        name: {
            jp: {
                A: 'F',
                text: 'しおり',
            },
        },
        type: Constant.FORM_TYPE.FIELD_RICHTEXT,
        structure: {
            UI: Constant.FIELD_UI.FIELD_RICHTEXT,
            elasticSearch: '',
            maxLength: Constant.RICHTEXT_MAX_LENGTH,
            minLength: 0
        },
        definition: Constant.FORM_DEFINITION.SYSTEM,
        sysfield: 'bookmark',
        id: 'bookmark',
        noInFormFileFormat: 4,
    },
    {
        usage: Constant.FORM_USAGE.FIELD,
        name: {
            jp: {
                A: 'F',
                text: '期限',
            },
        },
        type: Constant.FORM_TYPE.FIELD_TEXT,
        structure: {
            UI: Constant.FIELD_UI.TEXT,
            elasticSearch: '',
        },
        definition: Constant.FORM_DEFINITION.SYSTEM,
        sysfield: 'deadline',
        id: 'deadline',
    },
    {
        usage: Constant.FORM_USAGE.FIELD,
        name: {
            jp: {
                A: 'F',
                text: 'ポイント',
            },
        },
        type: Constant.FORM_TYPE.FIELD_TEXT,
        structure: {
            UI: Constant.FIELD_UI.TEXT,
            elasticSearch: '',
        },
        definition: Constant.FORM_DEFINITION.SYSTEM,
        sysfield: 'point',
        id: 'point',
    },
    {
        id: 'maxGeneralId',
        usage: Constant.FORM_USAGE.FIELD,
        name: {
            jp: {
                A: 'F',
                text: '利用可能なジェネラルユーザーID数',
            },
        },
        type: Constant.FORM_TYPE.FIELD_TEXT,
        structure: {
            UI: Constant.FIELD_UI.TEXT,
            elasticSearch: '',
            required: true,
            regExpr: /^[0-9]+$/,
        },
        definition: Constant.FORM_DEFINITION.SYSTEM,
        sysfield: 'maxGeneralId',
        noInFormInviteGuestDesk: 10,
    },
    // field AI Telephone Greeting (挨拶)
    {
        id: 'ai_telephone_greeting',
        usage: Constant.FORM_USAGE.FIELD,
        name: {
            jp: {
                A: 'F',
                text: 'AIからの開始メッセージ',
            },
        },
        type: Constant.FORM_TYPE.FIELD_TEXT,
        structure: {
            UI: Constant.FIELD_UI.TEXT_AREA,
            elasticSearch: '',
            maxLength: 2000,
        },
        definition: Constant.FORM_DEFINITION.SYSTEM,
        sysfield: 'ai_telephone_greeting',
        noInFormAITelephonePrompt: 6,
    },
    // field AI-Prompt Body
    {
        usage: Constant.FORM_USAGE.FIELD,
        name: {
            jp: {
                A: 'F',
                text: 'AI-プロンプト本文',
            },
        },
        type: Constant.FORM_TYPE.FIELD_RICHTEXT,
        structure: {
            UI: Constant.FIELD_UI.FIELD_RICHTEXT,
            elasticSearch: '',
            maxLength: Constant.RICHTEXT_MAX_LENGTH,
            minLength: 0
        },
        definition: Constant.FORM_DEFINITION.SYSTEM,
        sysfield: 'AIPromptBody',
        id: 'AIPromptBody',
        noInFormAIChatPrompt: 2,
        noInFormAITelephonePrompt: 7,
        noInFormAIAssistantPrompt: 6,
        noInFormAITrainingPrompt: 5,
    },
    // field Apply AI-prompt
    {
        usage: Constant.FORM_USAGE.FIELD,
        name: {
            jp: {
                A: 'F',
                text: 'AI-プロンプト適用',
            },
        },
        type: Constant.FORM_TYPE.FIELD_TAG,
        structure: {
            UI: Constant.FIELD_UI.TAG,
            elasticSearch: '',
            required: true,
            disableSettingRequired: true,
            optionType: Constant.TAG_FIELD_DEFAULT.CHECK_OPTION_TYPE,
            isMultiple: false,
            recordNumber: 2,
            isAddItem: false,
            settingSelectItem: false,
            
        },
        definition: Constant.FORM_DEFINITION.SYSTEM,
        sysfield: 'ApplyAIprompt',
        id: 'ApplyAIprompt',
        noInFormAIChatPrompt: 3,
        noInFormAITelephonePrompt: 9,
        noInFormAIAssistantPrompt: 8,
        noInFormAITrainingPrompt: 7,
    },
    // field option Apply AI-prompt
    {
        id: 'ApplyAIpromptOff',
        usage: Constant.FORM_USAGE.TAG,
        name: {
            jp: {
                A: 'F',
                text: 'OFF',
            },
        },
        affiliationField: 'ApplyAIprompt',
        type: '',
        structure: {
            isShowItemInTicket: true,
            no: 1,
        },
        viewForCustomer: {},
        definition: Constant.FORM_DEFINITION.SYSTEM,
        sysfield: 'ApplyAIpromptOff',
    },
    {
        id: 'ApplyAIpromptOn',
        usage: Constant.FORM_USAGE.TAG,
        name: {
            jp: {
                A: 'F',
                text: 'ON',
            },
        },
        affiliationField: 'ApplyAIprompt',
        type: '',
        structure: {
            isShowItemInTicket: true,
            no: 2,
        },
        viewForCustomer: {},
        definition: Constant.FORM_DEFINITION.SYSTEM,
        sysfield: 'ApplyAIpromptOn',
    },
    // field AI-Prompt application target
    {
        usage: Constant.FORM_USAGE.FIELD,
        name: {
            jp: {
                A: 'F',
                text: 'AI-プロンプト適用先',
            },
        },
        type: Constant.FORM_TYPE.FIELD_TAG,
        structure: {
            UI: Constant.FIELD_UI.TAG,
            elasticSearch: '',
            optionType: Constant.TAG_FIELD_DEFAULT.CHECK_OPTION_TYPE,
            isMultiple: true,
            recordNumber: 2,
            isAddItem: false,
            settingSelectItem: Constant.SETTING_SELECT_ITEM_TAG_FIELD.DEFAULT,
        },
        definition: Constant.FORM_DEFINITION.SYSTEM,
        sysfield: 'AIPromptApplicationTarget',
        id: 'AIPromptApplicationTarget',
        noInFormAIChatPrompt: 4
    },
    // field option AI-Prompt application target
    {
        id: 'AIPromptApplicationTargetInternal',
        usage: Constant.FORM_USAGE.TAG,
        name: {
            jp: {
                A: 'F',
                text: '内部',
            },
        },
        affiliationField: 'AIPromptApplicationTarget',
        type: '',
        structure: {
            isShowItemInTicket: true,
            no: 1,
        },
        viewForCustomer: {},
        definition: Constant.FORM_DEFINITION.SYSTEM,
        sysfield: 'AIPromptApplicationTargetInternal',
    },
    {
        id: 'AIPromptApplicationTargetExternal',
        usage: Constant.FORM_USAGE.TAG,
        name: {
            jp: {
                A: 'F',
                text: '外部',
            },
        },
        affiliationField: 'AIPromptApplicationTarget',
        type: '',
        structure: {
            isShowItemInTicket: true,
            no: 2,
        },
        viewForCustomer: {},
        definition: Constant.FORM_DEFINITION.SYSTEM,
        sysfield: 'AIPromptApplicationTargetExternal',
    },
    // field ページ番号 <Page No>
    {
        id: 'pageNo',
        usage: Constant.FORM_USAGE.FIELD,
        name: {
            jp: {
                A: 'F',
                text: 'ページ番号',
            },
        },
        type: Constant.FORM_TYPE.FIELD_INT,
        structure: {
            UI: Constant.FIELD_UI.NUMBER,
            elasticSearch: '',
            required: true,
            regExpr: /^[0-9]+$/,
        },
        definition: Constant.FORM_DEFINITION.SYSTEM,
        sysfield: 'pageNo',
        noInFormPageFormat: 4,
    },
    // field 章 <Chapter>
    {
        id: 'chapter',
        usage: Constant.FORM_USAGE.FIELD,
        name: {
            jp: {
                A: 'F',
                text: '章',
            },
        },
        type: Constant.FORM_TYPE.FIELD_TAG,
        isRequiedPageKnowledgeField: true,
        dataValue: '',
        structure: {
            UI: Constant.FIELD_UI.TAG,
            optionType: Constant.TAG_FIELD_DEFAULT.SELECT_OPTION_TYPE,
            recordNumber: Constant.TAG_FIELD_DEFAULT.RECORD_NUMBER,
            settingSelectItem: Constant.SETTING_SELECT_ITEM_TAG_FIELD.DEFAULT,
            displayOrder: Constant.DISPLAY_ORDER_TAG_FIELD.DEFAULT,
            isMultiple: false,
            elasticSearch: '',
            // isAddItem: false,
            // required: true,
        },
        definition: Constant.FORM_DEFINITION.SYSTEM,
        sysfield: 'chapter',
        noInFormPageFormat: 5,
    },
    // field 節 <Section>
    {
        id: 'section',
        usage: Constant.FORM_USAGE.FIELD,
        name: {
            jp: {
                A: 'F',
                text: '節',
            },
        },
        type: Constant.FORM_TYPE.FIELD_TAG,
        isRequiedPageKnowledgeField: true,
        dataValue: '',
        structure: {
            UI: Constant.FIELD_UI.TAG,
            optionType: Constant.TAG_FIELD_DEFAULT.SELECT_OPTION_TYPE,
            recordNumber: Constant.TAG_FIELD_DEFAULT.RECORD_NUMBER,
            settingSelectItem: Constant.SETTING_SELECT_ITEM_TAG_FIELD.DEFAULT,
            displayOrder: Constant.DISPLAY_ORDER_TAG_FIELD.DEFAULT,
            isMultiple: false,
            elasticSearch: '',
            // isAddItem: false,
            // required: true,
        },
        definition: Constant.FORM_DEFINITION.SYSTEM,
        sysfield: 'section',
        noInFormPageFormat: 6,
    },
    // field 項 <Sub-Section>
    {
        id: 'subSection',
        usage: Constant.FORM_USAGE.FIELD,
        name: {
            jp: {
                A: 'F',
                text: '項',
            },
        },
        type: Constant.FORM_TYPE.FIELD_TAG,
        isRequiedPageKnowledgeField: true,
        dataValue: '',
        structure: {
            UI: Constant.FIELD_UI.TAG,
            optionType: Constant.TAG_FIELD_DEFAULT.SELECT_OPTION_TYPE,
            recordNumber: Constant.TAG_FIELD_DEFAULT.RECORD_NUMBER,
            settingSelectItem: Constant.SETTING_SELECT_ITEM_TAG_FIELD.DEFAULT,
            displayOrder: Constant.DISPLAY_ORDER_TAG_FIELD.DEFAULT,
            isMultiple: false,
            elasticSearch: '',
            // isAddItem: false,
            // required: true,
        },
        definition: Constant.FORM_DEFINITION.SYSTEM,
        sysfield: 'subSection',
        noInFormPageFormat: 7,
    },
    // field 目 <Item>
    {
        id: 'item',
        usage: Constant.FORM_USAGE.FIELD,
        name: {
            jp: {
                A: 'F',
                text: '目',
            },
        },
        type: Constant.FORM_TYPE.FIELD_TAG,
        isRequiedPageKnowledgeField: true,
        dataValue: '',
        structure: {
            UI: Constant.FIELD_UI.TAG,
            optionType: Constant.TAG_FIELD_DEFAULT.SELECT_OPTION_TYPE,
            recordNumber: Constant.TAG_FIELD_DEFAULT.RECORD_NUMBER,
            settingSelectItem: Constant.SETTING_SELECT_ITEM_TAG_FIELD.DEFAULT,
            displayOrder: Constant.DISPLAY_ORDER_TAG_FIELD.DEFAULT,
            isMultiple: false,
            elasticSearch: '',
            // isAddItem: false,
            // required: true,
        },
        definition: Constant.FORM_DEFINITION.SYSTEM,
        sysfield: 'item',
        noInFormPageFormat: 8,
    },
    {
        usage: Constant.FORM_USAGE.FIELD,
        name: {
            jp: {
                A: 'F',
                text: '類義語一覧',
            },
        },
        type: Constant.FORM_TYPE.FIELD_TEXT,
        structure: {
            UI: Constant.FIELD_UI.TEXT_AREA,
            elasticSearch: '',
            required: false,
            maxLength: 20000,
            minLength: 0
        },
        definition: Constant.FORM_DEFINITION.SYSTEM,
        sysfield: 'listOfSynonyms',
        id: 'listOfSynonyms',
    },

    // Email ticket
    {
        usage: Constant.FORM_USAGE.FIELD,
        name: {
            jp: {
                A: 'F',
                text: 'From',
            },
        },
        type: Constant.FORM_TYPE.FIELD_TEXT,
        structure: {
            UI: Constant.FIELD_UI.TEXT,
            elasticSearch: '',
            required: true
        },
        definition: Constant.FORM_DEFINITION.SYSTEM,
        sysfield: 'from',
        id: 'from',
        noInFormEmail: 3
    },
    {
        usage: Constant.FORM_USAGE.FIELD,
        name: {
            jp: {
                A: 'F',
                text: 'To',
            },
        },
        type: Constant.FORM_TYPE.FIELD_TEXT,
        structure: {
            UI: Constant.FIELD_UI.TEXT_WITH_CHIP,
            elasticSearch: '',
            required: true
        },
        definition: Constant.FORM_DEFINITION.SYSTEM,
        sysfield: 'to',
        id: 'to',
        noInFormEmail: 4
    },
    {
        usage: Constant.FORM_USAGE.FIELD,
        name: {
            jp: {
                A: 'F',
                text: 'Cc',
            },
        },
        type: Constant.FORM_TYPE.FIELD_TEXT,
        structure: {
            UI: Constant.FIELD_UI.TEXT_WITH_CHIP,
            elasticSearch: ''
        },
        definition: Constant.FORM_DEFINITION.SYSTEM,
        sysfield: 'cc',
        id: 'cc',
        noInFormEmail: 5
    },
    {
        usage: Constant.FORM_USAGE.FIELD,
        name: {
            jp: {
                A: 'F',
                text: 'Bcc',
            },
        },
        type: Constant.FORM_TYPE.FIELD_TEXT,
        structure: {
            UI: Constant.FIELD_UI.TEXT_WITH_CHIP,
            elasticSearch: ''
        },
        definition: Constant.FORM_DEFINITION.SYSTEM,
        sysfield: 'bcc',
        id: 'bcc',
        noInFormEmail: 6
    },
    {
        usage: Constant.FORM_USAGE.FIELD,
        name: {
            jp: {
                A: 'F',
                text: '件名',
            },
        },
        type: Constant.FORM_TYPE.FIELD_TEXT,
        structure: {
            UI: Constant.FIELD_UI.TEXT,
            elasticSearch: ''
        },
        definition: Constant.FORM_DEFINITION.SYSTEM,
        sysfield: 'mailSubject',
        id: 'mailSubject',
        noInFormEmail: 7
    },
    {
        usage: Constant.FORM_USAGE.FIELD,
        name: {
            jp: {
                A: 'F',
                text: '本文',
            },
        },
        type: Constant.FORM_TYPE.FIELD_RICHTEXT,
        structure: {
            UI: Constant.FIELD_UI.FIELD_RICHTEXT,
            elasticSearch: '',
            maxLength: 20000
        },
        definition: Constant.FORM_DEFINITION.SYSTEM,
        sysfield: 'mailBody',
        id: 'mailBody',
        noInFormEmail: 8
    },
    {
        usage: Constant.FORM_USAGE.FIELD,
        name: {
            jp: {
                A: 'F',
                text: 'reCAPTCHAによる検証を有効にする',
            },
        },
        type: Constant.FORM_TYPE.FIELD_TAG,
        structure: {
            UI: Constant.FIELD_UI.TAG,
            elasticSearch: '',
            required: true,
            disableSettingRequired: true,
            optionType: Constant.TAG_FIELD_DEFAULT.CHECK_OPTION_TYPE,
            isMultiple: false,
            recordNumber: 2,
            isAddItem: false,
            settingSelectItem: false,
            
        },
        definition: Constant.FORM_DEFINITION.SYSTEM,
        sysfield: 'sdauto_re_captcha',
        id: 'sdauto_re_captcha',
        noInSDAutoForm: 12,
    },
    {
        id: 'sdauto_re_captcha_off',
        usage: Constant.FORM_USAGE.TAG,
        name: {
            jp: {
                A: 'F',
                text: 'OFF',
            },
        },
        affiliationField: 'sdauto_re_captcha',
        type: '',
        structure: {
            isShowItemInTicket: true,
            no: 1,
        },
        viewForCustomer: {},
        definition: Constant.FORM_DEFINITION.SYSTEM,
        sysfield: 'sdauto_re_captcha_off',
    },
    {
        id: 'sdauto_re_captcha_on',
        usage: Constant.FORM_USAGE.TAG,
        name: {
            jp: {
                A: 'F',
                text: 'ON',
            },
        },
        affiliationField: 'sdauto_re_captcha',
        type: '',
        structure: {
            isShowItemInTicket: true,
            no: 2,
        },
        viewForCustomer: {},
        definition: Constant.FORM_DEFINITION.SYSTEM,
        sysfield: 'sdauto_re_captcha_on',
    },
    // ChatGPTモデル field
    {
        id: 'field_chatgpt_model_ai_auto',
        sysfield: 'field_chatgpt_model_ai_auto',
        usage: Constant.FORM_USAGE.FIELD,
        name: {
            jp: {
                A: 'F',
                text: 'ChatGPTモデル',
            },
        },
        type: Constant.FORM_TYPE.FIELD_TAG,
        noInFormAIChatPrompt: 2,
        noInFormAIAssistantPrompt: 3,
        structure: {
            UI: Constant.FIELD_UI.TAG,
            elasticSearch: '',
            optionType: Constant.TAG_FIELD_DEFAULT.SELECT_OPTION_TYPE,
            isMultiple: false,
            recordNumber: 5,
            isAddItem: false,
            settingSelectItem: Constant.SETTING_SELECT_ITEM_TAG_FIELD.DEFAULT,
            required: true,
        },
        definition: Constant.FORM_DEFINITION.SYSTEM,
    },
    // items in above field ChatGPT Model
    {
        id: 'field_chatgpt_model_ai_auto_tag_4o',
        usage: Constant.FORM_USAGE.TAG,
        name: {
            jp: {
                A: 'F',
                text: 'gpt-4o',
            },
        },
        affiliationField: 'field_chatgpt_model_ai_auto',
        type: '',
        structure: {
            isShowItemInTicket: true,
            no: 1,
        },
        viewForCustomer: {},
        definition: Constant.FORM_DEFINITION.SYSTEM,
        sysfield: 'field_chatgpt_model_ai_auto_tag_4o',
    },
    {
        id: 'field_chatgpt_model_ai_auto_tag_41',
        usage: Constant.FORM_USAGE.TAG,
        name: {
            jp: {
                A: 'F',
                text: 'gpt-4.1',
            },
        },
        affiliationField: 'field_chatgpt_model_ai_auto',
        type: '',
        structure: {
            isShowItemInTicket: true,
            no: 4,
        },
        viewForCustomer: {},
        definition: Constant.FORM_DEFINITION.SYSTEM,
        sysfield: 'field_chatgpt_model_ai_auto_tag_41',
    },
    {
        id: 'field_chatgpt_model_ai_auto_tag_5',
        usage: Constant.FORM_USAGE.TAG,
        name: {
            jp: {
                A: 'F',
                text: 'gpt-5',
            },
        },
        affiliationField: 'field_chatgpt_model_ai_auto',
        type: '',
        structure: {
            isShowItemInTicket: true,
            no: 5,
        },
        viewForCustomer: {},
        definition: Constant.FORM_DEFINITION.SYSTEM,
        sysfield: 'field_chatgpt_model_ai_auto_tag_5',
    },
    {
        id: 'field_chatgpt_model_ai_auto_tag_52',
        usage: Constant.FORM_USAGE.TAG,
        name: {
            jp: {
                A: 'F',
                text: 'gpt-5.2',
            },
        },
        affiliationField: 'field_chatgpt_model_ai_auto',
        type: '',
        structure: {
            isShowItemInTicket: true,
            no: 6,
        },
        viewForCustomer: {},
        definition: Constant.FORM_DEFINITION.SYSTEM,
        sysfield: 'field_chatgpt_model_ai_auto_tag_52',
    },
    {
        id: 'field_chatgpt_model_ai_auto_tag_54',
        usage: Constant.FORM_USAGE.TAG,
        name: {
            jp: {
                A: 'F',
                text: 'gpt-5.4',
            },
        },
        affiliationField: 'field_chatgpt_model_ai_auto',
        type: '',
        structure: {
            isShowItemInTicket: true,
            no: 7,
        },
        viewForCustomer: {},
        definition: Constant.FORM_DEFINITION.SYSTEM,
        sysfield: 'field_chatgpt_model_ai_auto_tag_54',
    },
    {
        id: 'field_chatgpt_model_ai_auto_tag_54_mini',
        usage: Constant.FORM_USAGE.TAG,
        name: {
            jp: {
                A: 'F',
                text: 'gpt-5.4-mini',
            },
        },
        affiliationField: 'field_chatgpt_model_ai_auto',
        type: '',
        structure: {
            isShowItemInTicket: true,
            no: 8,
        },
        viewForCustomer: {},
        definition: Constant.FORM_DEFINITION.SYSTEM,
        sysfield: 'field_chatgpt_model_ai_auto_tag_54_mini',
    },
    {
        id: 'field_chatgpt_model_ai_auto_tag_55',
        usage: Constant.FORM_USAGE.TAG,
        name: {
            jp: {
                A: 'F',
                text: 'gpt-5.5',
            },
        },
        affiliationField: 'field_chatgpt_model_ai_auto',
        type: '',
        structure: {
            isShowItemInTicket: true,
            no: 9,
        },
        viewForCustomer: {},
        definition: Constant.FORM_DEFINITION.SYSTEM,
        sysfield: 'field_chatgpt_model_ai_auto_tag_55',
    },
    {
        id: 'field_chatgpt_model_ai_auto_tag_56_sol',
        usage: Constant.FORM_USAGE.TAG,
        name: {
            jp: {
                A: 'F',
                text: 'gpt-5.6-sol',
            },
        },
        affiliationField: 'field_chatgpt_model_ai_auto',
        type: '',
        structure: {
            isShowItemInTicket: true,
            no: 12,
        },
        viewForCustomer: {},
        definition: Constant.FORM_DEFINITION.SYSTEM,
        sysfield: 'field_chatgpt_model_ai_auto_tag_56_sol',
    },
    {
        id: 'field_chatgpt_model_ai_auto_tag_6_astra',
        usage: Constant.FORM_USAGE.TAG,
        name: {
            jp: {
                A: 'F',
                text: 'gpt-6-astra',
            },
        },
        affiliationField: 'field_chatgpt_model_ai_auto',
        type: '',
        structure: {
            isShowItemInTicket: true,
            no: 13,
        },
        viewForCustomer: {},
        definition: Constant.FORM_DEFINITION.SYSTEM,
        sysfield: 'field_chatgpt_model_ai_auto_tag_6_astra',
    },
    {
        id: 'field_chatgpt_model_ai_auto_tag_56_terra',
        usage: Constant.FORM_USAGE.TAG,
        name: {
            jp: {
                A: 'F',
                text: 'gpt-5.6-terra',
            },
        },
        affiliationField: 'field_chatgpt_model_ai_auto',
        type: '',
        structure: {
            isShowItemInTicket: true,
            no: 11,
        },
        viewForCustomer: {},
        definition: Constant.FORM_DEFINITION.SYSTEM,
        sysfield: 'field_chatgpt_model_ai_auto_tag_56_terra',
    },
    {
        id: 'field_chatgpt_model_ai_auto_tag_56_luna',
        usage: Constant.FORM_USAGE.TAG,
        name: {
            jp: {
                A: 'F',
                text: 'gpt-5.6-luna',
            },
        },
        affiliationField: 'field_chatgpt_model_ai_auto',
        type: '',
        structure: {
            isShowItemInTicket: true,
            no: 10,
        },
        viewForCustomer: {},
        definition: Constant.FORM_DEFINITION.SYSTEM,
        sysfield: 'field_chatgpt_model_ai_auto_tag_56_luna',
    },
    {
        id: 'field_chatgpt_model_ai_auto_tag_no',
        usage: Constant.FORM_USAGE.TAG,
        name: {
            jp: {
                A: 'F',
                text: 'No Preference',
            },
        },
        affiliationField: 'field_chatgpt_model_ai_auto',
        type: '',
        structure: {
            isShowItemInTicket: true,
            no: 99,
        },
        viewForCustomer: {},
        definition: Constant.FORM_DEFINITION.SYSTEM,
        sysfield: 'field_chatgpt_model_ai_auto_tag_no',
    },
    // 推論レベル field
    {
        id: 'field_reasoning_effort_ai_auto',
        sysfield: 'field_reasoning_effort_ai_auto',
        usage: Constant.FORM_USAGE.FIELD,
        name: {
            jp: {
                A: 'F',
                text: '推論レベル',
            },
        },
        type: Constant.FORM_TYPE.FIELD_TAG,
        noInFormAIChatPrompt: 3,
        noInFormAIAssistantPrompt: 4,
        structure: {
            UI: Constant.FIELD_UI.TAG,
            elasticSearch: '',
            optionType: Constant.TAG_FIELD_DEFAULT.SELECT_OPTION_TYPE,
            isMultiple: false,
            recordNumber: 4,
            isAddItem: false,
            settingSelectItem: Constant.SETTING_SELECT_ITEM_TAG_FIELD.DEFAULT,
            required: true,
        },
        definition: Constant.FORM_DEFINITION.SYSTEM,
    },
    // items in above field 推論レベル
    {
        id: 'field_reasoning_effort_ai_auto_none',
        usage: Constant.FORM_USAGE.TAG,
        name: {
            jp: {
                A: 'F',
                text: 'none',
            },
        },
        affiliationField: 'field_reasoning_effort_ai_auto',
        type: '',
        structure: {
            isShowItemInTicket: true,
            no: 1.5,
        },
        viewForCustomer: {},
        definition: Constant.FORM_DEFINITION.SYSTEM,
        sysfield: 'field_reasoning_effort_ai_auto_none',
    },
    {
        id: 'field_reasoning_effort_ai_auto_minimal',
        usage: Constant.FORM_USAGE.TAG,
        name: {
            jp: {
                A: 'F',
                text: 'minimal',
            },
        },
        affiliationField: 'field_reasoning_effort_ai_auto',
        type: '',
        structure: {
            isShowItemInTicket: true,
            no: 1,
        },
        viewForCustomer: {},
        definition: Constant.FORM_DEFINITION.SYSTEM,
        sysfield: 'field_reasoning_effort_ai_auto_minimal',
    },
    {
        id: 'field_reasoning_effort_ai_auto_low',
        usage: Constant.FORM_USAGE.TAG,
        name: {
            jp: {
                A: 'F',
                text: 'low',
            },
        },
        affiliationField: 'field_reasoning_effort_ai_auto',
        type: '',
        structure: {
            isShowItemInTicket: true,
            no: 2,
        },
        viewForCustomer: {},
        definition: Constant.FORM_DEFINITION.SYSTEM,
        sysfield: 'field_reasoning_effort_ai_auto_low',
    },
    {
        id: 'field_reasoning_effort_ai_auto_medium',
        usage: Constant.FORM_USAGE.TAG,
        name: {
            jp: {
                A: 'F',
                text: 'medium',
            },
        },
        affiliationField: 'field_reasoning_effort_ai_auto',
        type: '',
        structure: {
            isShowItemInTicket: true,
            no: 3,
        },
        viewForCustomer: {},
        definition: Constant.FORM_DEFINITION.SYSTEM,
        sysfield: 'field_reasoning_effort_ai_auto_medium',
    },
    {
        id: 'field_reasoning_effort_ai_auto_high',
        usage: Constant.FORM_USAGE.TAG,
        name: {
            jp: {
                A: 'F',
                text: 'high',
            },
        },
        affiliationField: 'field_reasoning_effort_ai_auto',
        type: '',
        structure: {
            isShowItemInTicket: true,
            no: 4,
        },
        viewForCustomer: {},
        definition: Constant.FORM_DEFINITION.SYSTEM,
        sysfield: 'field_reasoning_effort_ai_auto_high',
    },
    {
        id: 'field_reasoning_effort_ai_auto_xhigh',
        usage: Constant.FORM_USAGE.TAG,
        name: {
            jp: {
                A: 'F',
                text: 'xhigh',
            },
        },
        affiliationField: 'field_reasoning_effort_ai_auto',
        type: '',
        structure: {
            isShowItemInTicket: true,
            no: 5,
        },
        viewForCustomer: {},
        definition: Constant.FORM_DEFINITION.SYSTEM,
        sysfield: 'field_reasoning_effort_ai_auto_xhigh',
    },
    {
        id: 'field_reasoning_effort_ai_auto_max',
        usage: Constant.FORM_USAGE.TAG,
        name: {
            jp: {
                A: 'F',
                text: 'max',
            },
        },
        affiliationField: 'field_reasoning_effort_ai_auto',
        type: '',
        structure: {
            isShowItemInTicket: true,
            no: 6,
        },
        viewForCustomer: {},
        definition: Constant.FORM_DEFINITION.SYSTEM,
        sysfield: 'field_reasoning_effort_ai_auto_max',
    },
    // 外部連携設定 field
    {
        id: 'field_mcp_server_setting',
        sysfield: 'field_mcp_server_setting',
        usage: Constant.FORM_USAGE.FIELD,
        type: Constant.FORM_TYPE.FIELD_TAG,
        definition: Constant.FORM_DEFINITION.SYSTEM,
        name: {
            jp: {
                A: 'F',
                text: '外部連携設定',
            },
        },
        structure: {
            UI: Constant.FIELD_UI.TEXT_WITH_CHIP,
            elasticSearch: '',
            optionType: Constant.TAG_FIELD_DEFAULT.SELECT_OPTION_TYPE,
            isMultiple: true,
            recordNumber: Constant.TAG_FIELD_DEFAULT.RECORD_NUMBER,
            isAddItem: false,
            settingSelectItem: Constant.SETTING_SELECT_ITEM_TAG_FIELD.DEFAULT,
            required: false,
        },
        noInFormAIChatPrompt: 5,
        noInFormAIAssistantPrompt: 9,
        noInBusinessAppForm: 6,
    },
    // field Kibana Analysis (分析機能) - CR-297430
    {
        id: 'field_kibana_analysis',
        sysfield: 'field_kibana_analysis',
        usage: Constant.FORM_USAGE.FIELD,
        type: Constant.FORM_TYPE.FIELD_TAG,
        definition: Constant.FORM_DEFINITION.SYSTEM,
        name: {
            jp: {
                A: 'F',
                text: '分析機能',
            },
        },
        structure: {
            UI: Constant.FIELD_UI.TAG,
            elasticSearch: '',
            optionType: Constant.TAG_FIELD_DEFAULT.CHECK_OPTION_TYPE,
            isMultiple: false,
            recordNumber: 2,
            isAddItem: false,
            settingSelectItem: false,
            required: false,
        },
        noInFormAIChatPrompt: 6,
        noInAIAutoEventForm: 6,
        noInAIAutoTimerForm: 6,
        noInAIAutoPeriodicForm: 6,
    },
    // field option Kibana Analysis - OFF
    {
        id: 'field_kibana_analysis_off',
        usage: Constant.FORM_USAGE.TAG,
        name: {
            jp: {
                A: 'F',
                text: 'OFF',
            },
        },
        affiliationField: 'field_kibana_analysis',
        type: '',
        structure: {
            isShowItemInTicket: true,
            no: 1,
        },
        viewForCustomer: {},
        definition: Constant.FORM_DEFINITION.SYSTEM,
        sysfield: 'field_kibana_analysis_off',
    },
    // field option Kibana Analysis - ON
    {
        id: 'field_kibana_analysis_on',
        usage: Constant.FORM_USAGE.TAG,
        name: {
            jp: {
                A: 'F',
                text: 'ON',
            },
        },
        affiliationField: 'field_kibana_analysis',
        type: '',
        structure: {
            isShowItemInTicket: true,
            no: 2,
        },
        viewForCustomer: {},
        definition: Constant.FORM_DEFINITION.SYSTEM,
        sysfield: 'field_kibana_analysis_on',
    },
    // 説明 (Description) field for SD Auto / AI Telephone / AI Assistant
    {
        id: 'sdauto_description',
        sysfield: 'sdauto_description',
        usage: Constant.FORM_USAGE.FIELD,
        name: {
            jp: {
                A: 'F',
                text: '説明',
            },
        },
        type: Constant.FORM_TYPE.FIELD_RICHTEXT,
        structure: {
            UI: Constant.FIELD_UI.FIELD_RICHTEXT,
            elasticSearch: '',
            maxLength: Constant.RICHTEXT_MAX_LENGTH,
            minLength: 0
        },
        definition: Constant.FORM_DEFINITION.SYSTEM,
        noInSDAutoForm: 4,
        noInFormAITelephonePrompt: 4,
        noInFormAIAssistantPrompt: 5,
        noInFormAITrainingPrompt: 4,
    },
    // ダイアグラム (Mermaid) field
    {
        id: 'sdauto_script_flow',
        sysfield: 'sdauto_script_flow',
        usage: Constant.FORM_USAGE.FIELD,
        name: {
            jp: {
                A: 'F',
                text: 'ダイアグラム',
            },
        },
        type: Constant.FORM_TYPE.MERMAID,
        structure: {
            UI: Constant.FIELD_UI.MERMAID,
            minLength: 0,
            elasticSearch: '',
        },
        definition: Constant.FORM_DEFINITION.SYSTEM,
        noInSDAutoForm: 6,
        noInFormAITelephonePrompt: 8,
        noInFormAIAssistantPrompt: 7,
        noInFormAITrainingPrompt: 6,
    },
    // AI Telephone Prompt fields start
    {
        id: 'ai_telephone_operator_name',
        sysfield: 'ai_telephone_operator_name',
        usage: Constant.FORM_USAGE.FIELD,
        name: {
            jp: {
                A: 'F',
                text: 'AIオペレータ名',
            },
        },
        type: Constant.FORM_TYPE.FIELD_TEXT,
        structure: {
            UI: Constant.FIELD_UI.TEXT,
            elasticSearch: '',
            maxLength: 100,
            required: true,
        },
        definition: Constant.FORM_DEFINITION.SYSTEM,
        noInFormAITelephonePrompt: 2,
        noInFormAIAssistantPrompt: 2,
        noInFormAITrainingPrompt: 2,
    },

    {
        id: 'ai_telephone_trigger_condition',
        sysfield: 'ai_telephone_trigger_condition',
        usage: Constant.FORM_USAGE.FIELD,
        name: {
            jp: {
                A: 'F',
                text: 'AI-プロンプト実行条件',
            },
        },
        type: Constant.FORM_TYPE.FIELD_TAG,
        structure: {
            UI: Constant.FIELD_UI.TAG,
            elasticSearch: '',
            optionType: Constant.TAG_FIELD_DEFAULT.SELECT_OPTION_TYPE,
            isMultiple: true,
            recordNumber: 4,
            isAddItem: false,
            settingSelectItem: Constant.SETTING_SELECT_ITEM_TAG_FIELD.DEFAULT,
            required: true,
        },
        definition: Constant.FORM_DEFINITION.SYSTEM,
        noInFormAITelephonePrompt: 11,
        noInFormAIAssistantPrompt: 10,
    },
    // items in above field AI-プロンプト実行条件
    {
        id: 'ai_telephone_trigger_condition_receiving',
        usage: Constant.FORM_USAGE.TAG,
        name: {
            jp: {
                A: 'F',
                text: '受信時',
            },
        },
        affiliationField: 'ai_telephone_trigger_condition',
        type: '',
        structure: {
            isShowItemInTicket: true,
            no: 1,
        },
        viewForCustomer: {},
        definition: Constant.FORM_DEFINITION.SYSTEM,
        sysfield: 'ai_telephone_trigger_condition_receiving',
    },
    {
        id: 'ai_telephone_trigger_condition_making',
        usage: Constant.FORM_USAGE.TAG,
        name: {
            jp: {
                A: 'F',
                text: '発信時',
            },
        },
        affiliationField: 'ai_telephone_trigger_condition',
        type: '',
        structure: {
            isShowItemInTicket: true,
            no: 2,
        },
        viewForCustomer: {},
        definition: Constant.FORM_DEFINITION.SYSTEM,
        sysfield: 'ai_telephone_trigger_condition_making',
    },
    {
        id: 'ai_telephone_trigger_condition_training',
        usage: Constant.FORM_USAGE.TAG,
        name: {
            jp: {
                A: 'F',
                text: 'トレーニング時',
            },
        },
        affiliationField: 'ai_telephone_trigger_condition',
        type: '',
        structure: {
            isShowItemInTicket: true,
            no: 3,
        },
        viewForCustomer: {},
        definition: Constant.FORM_DEFINITION.SYSTEM,
        sysfield: 'ai_telephone_trigger_condition_training',
    },
    {
        id: 'ai_telephone_trigger_condition_app_integration',
        usage: Constant.FORM_USAGE.TAG,
        name: {
            jp: {
                A: 'F',
                text: 'アプリ連携時',
            },
        },
        affiliationField: 'ai_telephone_trigger_condition',
        type: '',
        structure: {
            isShowItemInTicket: true,
            no: 4,
        },
        viewForCustomer: {},
        definition: Constant.FORM_DEFINITION.SYSTEM,
        sysfield: 'ai_telephone_trigger_condition_app_integration',
    },
    {
        id: 'ai_telephone_receiving_call_execution_mode',
        sysfield: 'ai_telephone_receiving_call_execution_mode',
        usage: Constant.FORM_USAGE.FIELD,
        name: {
            jp: {
                A: 'F',
                text: 'AI-対応モード',
            },
        },
        type: Constant.FORM_TYPE.FIELD_TAG,
        structure: {
            UI: Constant.FIELD_UI.TAG,
            elasticSearch: '',
            optionType: Constant.TAG_FIELD_DEFAULT.SELECT_OPTION_TYPE,
            isMultiple: false,
            recordNumber: 2,
            isAddItem: false,
            settingSelectItem: Constant.SETTING_SELECT_ITEM_TAG_FIELD.DEFAULT,
            required: true,
        },
        definition: Constant.FORM_DEFINITION.SYSTEM,
        noInFormAITelephonePrompt: 12,
    },
    // items in above field AI-対応モード
    {
        id: 'ai_telephone_receiving_call_execution_mode_immediate',
        usage: Constant.FORM_USAGE.TAG,
        name: {
            jp: {
                A: 'F',
                text: '即時応答モード',
            },
        },
        affiliationField: 'ai_telephone_receiving_call_execution_mode',
        type: '',
        structure: {
            isShowItemInTicket: true,
            no: 1,
        },
        viewForCustomer: {},
        definition: Constant.FORM_DEFINITION.SYSTEM,
        sysfield: 'ai_telephone_receiving_call_execution_mode_immediate',
    },
    {
        id: 'ai_telephone_receiving_call_execution_mode_answering_machine',
        usage: Constant.FORM_USAGE.TAG,
        name: {
            jp: {
                A: 'F',
                text: '留守番電話モード',
            },
        },
        affiliationField: 'ai_telephone_receiving_call_execution_mode',
        type: '',
        structure: {
            isShowItemInTicket: true,
            no: 2,
        },
        viewForCustomer: {},
        definition: Constant.FORM_DEFINITION.SYSTEM,
        sysfield: 'ai_telephone_receiving_call_execution_mode_answering_machine',
    },
    {
        id: 'ai_telephone_time_based_delay_response',
        usage: Constant.FORM_USAGE.FIELD,
        name: {
            jp: {
                A: 'F',
                text: 'AI対応開始までの待機時間 (秒)',
            },
        },
        type: Constant.FORM_TYPE.FIELD_INT,
        structure: {
            UI: Constant.FIELD_UI.NUMBER,
            elasticSearch: '',
            required: false,
        },
        definition: Constant.FORM_DEFINITION.SYSTEM,
        sysfield: 'ai_telephone_time_based_delay_response',
        noInFormAITelephonePrompt: 13,
    },
    {
        id: 'ai_telephone_receiving_call_execution_time_period',
        sysfield: 'ai_telephone_receiving_call_execution_time_period',
        usage: Constant.FORM_USAGE.FIELD,
        name: {
            jp: {
                A: 'F',
                text: '専用時間帯設定',
            },
        },
        type: Constant.FORM_TYPE.FIELD_TAG,
        structure: {
            UI: Constant.FIELD_UI.TAG,
            elasticSearch: '',
            optionType: Constant.TAG_FIELD_DEFAULT.CHECK_OPTION_TYPE,
            isMultiple: true,
            recordNumber: 1,
            isAddItem: false,
            settingSelectItem: Constant.SETTING_SELECT_ITEM_TAG_FIELD.DEFAULT,
            required: false,
            isOnlyCheckbox: true,
        },
        definition: Constant.FORM_DEFINITION.SYSTEM,
        noInFormAITelephonePrompt: 14,
    },
    // items in above field 専用時間帯を追加する
    {
        id: 'ai_telephone_receiving_call_execution_time_period_item',
        usage: Constant.FORM_USAGE.TAG,
        name: {
            jp: {
                A: 'F',
                text: '専用時間帯設定',
            },
        },
        affiliationField: 'ai_telephone_receiving_call_execution_time_period',
        type: '',
        structure: {
            isShowItemInTicket: true,
            no: 1,
        },
        viewForCustomer: {},
        definition: Constant.FORM_DEFINITION.SYSTEM,
        sysfield: 'ai_telephone_receiving_call_execution_time_period_item',
    },
    // {
    //     id: 'ai_telephone_receiving_call_execution_time_period_several_days',
    //     usage: Constant.FORM_USAGE.TAG,
    //     name: {
    //         jp: {
    //             A: 'F',
    //             text: '複数日',
    //         },
    //     },
    //     affiliationField: 'ai_telephone_receiving_call_execution_time_period',
    //     type: '',
    //     structure: {
    //         isShowItemInTicket: true,
    //         no: 2,
    //     },
    //     viewForCustomer: {},
    //     definition: Constant.FORM_DEFINITION.SYSTEM,
    //     sysfield: 'ai_telephone_receiving_call_execution_time_period_several_days',
    // },
    // {
    //     id: 'ai_telephone_receiving_call_execution_time_period_period',
    //     usage: Constant.FORM_USAGE.TAG,
    //     name: {
    //         jp: {
    //             A: 'F',
    //             text: '期間',
    //         },
    //     },
    //     affiliationField: 'ai_telephone_receiving_call_execution_time_period',
    //     type: '',
    //     structure: {
    //         isShowItemInTicket: true,
    //         no: 3,
    //     },
    //     viewForCustomer: {},
    //     definition: Constant.FORM_DEFINITION.SYSTEM,
    //     sysfield: 'ai_telephone_receiving_call_execution_time_period_period',
    // },
    {
        id: 'ai_telephone_receiving_call_execution_start_time',
        usage: Constant.FORM_USAGE.FIELD,
        name: {
            jp: {
                A: 'F',
                text: 'AI-実行開始時刻',
            },
        },
        type: Constant.FORM_TYPE.FIELD_DATE,
        structure: {
            UI: Constant.FIELD_UI.DATE,
            dateFormat: Constant.SETTING_DATE_FIELD_FORMAT.HHMM,
            elasticSearch: '',
            required: false,
        },
        definition: Constant.FORM_DEFINITION.SYSTEM,
        sysfield: 'ai_telephone_receiving_call_execution_start_time',
        noInFormAITelephonePrompt: 16,
    },
    {
        id: 'ai_telephone_receiving_call_execution_end_time',
        usage: Constant.FORM_USAGE.FIELD,
        name: {
            jp: {
                A: 'F',
                text: 'AI-実行終了時刻',
            },
        },
        type: Constant.FORM_TYPE.FIELD_DATE,
        structure: {
            UI: Constant.FIELD_UI.DATE,
            dateFormat: Constant.SETTING_DATE_FIELD_FORMAT.HHMM,
            elasticSearch: '',
            required: false,
        },
        definition: Constant.FORM_DEFINITION.SYSTEM,
        sysfield: 'ai_telephone_receiving_call_execution_end_time',
        noInFormAITelephonePrompt: 17,
    },
    {
        id: 'ai_telephone_receiving_call_execution_start_date',
        usage: Constant.FORM_USAGE.FIELD,
        name: {
            jp: {
                A: 'F',
                text: 'AI-実行開始日',
            },
        },
        type: Constant.FORM_TYPE.FIELD_DATE,
        structure: {
            UI: Constant.FIELD_UI.DATE,
            dateFormat: Constant.SETTING_DATE_FIELD_FORMAT.YYYYMMDD,
            elasticSearch: '',
            required: false,
        },
        definition: Constant.FORM_DEFINITION.SYSTEM,
        sysfield: 'ai_telephone_receiving_call_execution_start_date',
        noInFormAITelephonePrompt: 18,
    },
    {
        id: 'ai_telephone_receiving_call_execution_end_date',
        usage: Constant.FORM_USAGE.FIELD,
        name: {
            jp: {
                A: 'F',
                text: 'AI-実行終了日',
            },
        },
        type: Constant.FORM_TYPE.FIELD_DATE,
        structure: {
            UI: Constant.FIELD_UI.DATE,
            dateFormat: Constant.SETTING_DATE_FIELD_FORMAT.YYYYMMDD,
            elasticSearch: '',
            required: false,
        },
        definition: Constant.FORM_DEFINITION.SYSTEM,
        sysfield: 'ai_telephone_receiving_call_execution_end_date',
        noInFormAITelephonePrompt: 19,
    },
    {
        id: 'ai_telephone_receiving_call_execution_day_of_weeks',
        sysfield: 'ai_telephone_receiving_call_execution_day_of_weeks',
        usage: Constant.FORM_USAGE.FIELD,
        name: {
            jp: {
                A: 'F',
                text: '曜日',
            },
        },
        type: Constant.FORM_TYPE.FIELD_TAG,
        structure: {
            UI: Constant.FIELD_UI.TAG,
            elasticSearch: '',
            optionType: Constant.TAG_FIELD_DEFAULT.CHECK_OPTION_TYPE,
            isMultiple: true,
            recordNumber: 7,
            isAddItem: false,
            settingSelectItem: Constant.SETTING_SELECT_ITEM_TAG_FIELD.DEFAULT,
            required: false,
        },
        definition: Constant.FORM_DEFINITION.SYSTEM,
        noInFormAITelephonePrompt: 20,
    },
    // items in above field 曜日
    {
        id: 'ai_telephone_receiving_call_execution_day_of_weeks_monday',
        usage: Constant.FORM_USAGE.TAG,
        name: {
            jp: {
                A: 'F',
                text: '月曜日',
            },
        },
        affiliationField: 'ai_telephone_receiving_call_execution_day_of_weeks',
        type: '',
        structure: {
            isShowItemInTicket: true,
            no: 1,
        },
        viewForCustomer: {},
        definition: Constant.FORM_DEFINITION.SYSTEM,
        sysfield: 'ai_telephone_receiving_call_execution_day_of_weeks_monday',
    },
    {
        id: 'ai_telephone_receiving_call_execution_day_of_weeks_tuesday',
        usage: Constant.FORM_USAGE.TAG,
        name: {
            jp: {
                A: 'F',
                text: '火曜日',
            },
        },
        affiliationField: 'ai_telephone_receiving_call_execution_day_of_weeks',
        type: '',
        structure: {
            isShowItemInTicket: true,
            no: 2,
        },
        viewForCustomer: {},
        definition: Constant.FORM_DEFINITION.SYSTEM,
        sysfield: 'ai_telephone_receiving_call_execution_day_of_weeks_tuesday',
    },
    {
        id: 'ai_telephone_receiving_call_execution_day_of_weeks_wednesday',
        usage: Constant.FORM_USAGE.TAG,
        name: {
            jp: {
                A: 'F',
                text: '水曜日',
            },
        },
        affiliationField: 'ai_telephone_receiving_call_execution_day_of_weeks',
        type: '',
        structure: {
            isShowItemInTicket: true,
            no: 3,
        },
        viewForCustomer: {},
        definition: Constant.FORM_DEFINITION.SYSTEM,
        sysfield: 'ai_telephone_receiving_call_execution_day_of_weeks_wednesday',
    },
    {
        id: 'ai_telephone_receiving_call_execution_day_of_weeks_thursday',
        usage: Constant.FORM_USAGE.TAG,
        name: {
            jp: {
                A: 'F',
                text: '木曜日',
            },
        },
        affiliationField: 'ai_telephone_receiving_call_execution_day_of_weeks',
        type: '',
        structure: {
            isShowItemInTicket: true,
            no: 4,
        },
        viewForCustomer: {},
        definition: Constant.FORM_DEFINITION.SYSTEM,
        sysfield: 'ai_telephone_receiving_call_execution_day_of_weeks_thursday',
    },
    {
        id: 'ai_telephone_receiving_call_execution_day_of_weeks_friday',
        usage: Constant.FORM_USAGE.TAG,
        name: {
            jp: {
                A: 'F',
                text: '金曜日',
            },
        },
        affiliationField: 'ai_telephone_receiving_call_execution_day_of_weeks',
        type: '',
        structure: {
            isShowItemInTicket: true,
            no: 5,
        },
        viewForCustomer: {},
        definition: Constant.FORM_DEFINITION.SYSTEM,
        sysfield: 'ai_telephone_receiving_call_execution_day_of_weeks_friday',
    },
    {
        id: 'ai_telephone_receiving_call_execution_day_of_weeks_saturday',
        usage: Constant.FORM_USAGE.TAG,
        name: {
            jp: {
                A: 'F',
                text: '土曜日',
            },
        },
        affiliationField: 'ai_telephone_receiving_call_execution_day_of_weeks',
        type: '',
        structure: {
            isShowItemInTicket: true,
            no: 6,
        },
        viewForCustomer: {},
        definition: Constant.FORM_DEFINITION.SYSTEM,
        sysfield: 'ai_telephone_receiving_call_execution_day_of_weeks_saturday',
    },
    {
        id: 'ai_telephone_receiving_call_execution_day_of_weeks_sunday',
        usage: Constant.FORM_USAGE.TAG,
        name: {
            jp: {
                A: 'F',
                text: '日曜日',
            },
        },
        affiliationField: 'ai_telephone_receiving_call_execution_day_of_weeks',
        type: '',
        structure: {
            isShowItemInTicket: true,
            no: 7,
        },
        viewForCustomer: {},
        definition: Constant.FORM_DEFINITION.SYSTEM,
        sysfield: 'ai_telephone_receiving_call_execution_day_of_weeks_sunday',
    },
    {
        id: 'ai_telephone_applicable_phone_number',
        sysfield: 'ai_telephone_applicable_phone_number',
        usage: Constant.FORM_USAGE.FIELD,
        name: {
            jp: {
                A: 'F',
                text: '適用対象の電話番号',
            },
        },
        type: Constant.FORM_TYPE.FIELD_TAG,
        structure: {
            UI: Constant.FIELD_UI.TAG,
            elasticSearch: '',
            optionType: Constant.TAG_FIELD_DEFAULT.SELECT_OPTION_TYPE,
            isMultiple: false,
            recordNumber: 5,
            isAddItem: false,
            settingSelectItem: Constant.SETTING_SELECT_ITEM_TAG_FIELD.DEFAULT,
            required: false,
        },
        definition: Constant.FORM_DEFINITION.SYSTEM,
        noInFormAITelephonePrompt: 22,
        noInFormAIAssistantPrompt: 12,
    },
    {
        id: 'ai_telephone_execution_scope',
        sysfield: 'ai_telephone_execution_scope',
        usage: Constant.FORM_USAGE.FIELD,
        name: {
            jp: {
                A: 'F',
                text: 'AI-プロンプト適用範囲',
            },
        },
        type: Constant.FORM_TYPE.FIELD_TAG,
        structure: {
            UI: Constant.FIELD_UI.TAG,
            elasticSearch: '',
            optionType: Constant.TAG_FIELD_DEFAULT.SELECT_OPTION_TYPE,
            isMultiple: true,
            recordNumber: 2,
            isAddItem: false,
            settingSelectItem: Constant.SETTING_SELECT_ITEM_TAG_FIELD.DEFAULT,
            required: false,
        },
        definition: Constant.FORM_DEFINITION.SYSTEM,
        noInFormAITelephonePrompt: 21,
        noInFormAIAssistantPrompt: 11,
    },
    // items in above field AI-プロンプト適用範囲
    {
        id: 'ai_telephone_execution_scope_internal',
        usage: Constant.FORM_USAGE.TAG,
        name: {
            jp: {
                A: 'F',
                text: '内線',
            },
        },
        affiliationField: 'ai_telephone_execution_scope',
        type: '',
        structure: {
            isShowItemInTicket: true,
            no: 1,
        },
        viewForCustomer: {},
        definition: Constant.FORM_DEFINITION.SYSTEM,
        sysfield: 'ai_telephone_execution_scope_internal',
    },
    {
        id: 'ai_telephone_execution_scope_external',
        usage: Constant.FORM_USAGE.TAG,
        name: {
            jp: {
                A: 'F',
                text: '外線',
            },
        },
        affiliationField: 'ai_telephone_execution_scope',
        type: '',
        structure: {
            isShowItemInTicket: true,
            no: 2,
        },
        viewForCustomer: {},
        definition: Constant.FORM_DEFINITION.SYSTEM,
        sysfield: 'ai_telephone_execution_scope_external',
    },
    {
        id: 'ai_telephone_voice_settings',
        sysfield: 'ai_telephone_voice_settings',
        usage: Constant.FORM_USAGE.FIELD,
        name: {
            jp: {
                A: 'F',
                text: 'AI-音声設定',
            },
        },
        type: Constant.FORM_TYPE.FIELD_TAG,
        structure: {
            UI: Constant.FIELD_UI.TAG,
            elasticSearch: '',
            optionType: Constant.TAG_FIELD_DEFAULT.SELECT_OPTION_TYPE,
            isMultiple: false,
            recordNumber: 11,
            isAddItem: false,
            settingSelectItem: Constant.SETTING_SELECT_ITEM_TAG_FIELD.DEFAULT,
            required: false,
        },
        definition: Constant.FORM_DEFINITION.SYSTEM,
        noInFormAITelephonePrompt: 23,
        noInFormAITrainingPrompt: 9,
    },
    // items in above field AI-音声設定
    {
        id: 'ai_telephone_voice_settings_alloy',
        usage: Constant.FORM_USAGE.TAG,
        name: {
            jp: {
                A: 'F',
                text: 'alloy (力強くメタリックな声)',
            },
        },
        affiliationField: 'ai_telephone_voice_settings',
        type: '',
        structure: {
            isShowItemInTicket: true,
            no: 1,
        },
        viewForCustomer: {},
        definition: Constant.FORM_DEFINITION.SYSTEM,
        sysfield: 'ai_telephone_voice_settings_alloy',
    },
    {
        id: 'ai_telephone_voice_settings_ash',
        usage: Constant.FORM_USAGE.TAG,
        name: {
            jp: {
                A: 'F',
                text: 'ash (落ち着いた柔らかい声)',
            },
        },
        affiliationField: 'ai_telephone_voice_settings',
        type: '',
        structure: {
            isShowItemInTicket: true,
            no: 2,
        },
        viewForCustomer: {},
        definition: Constant.FORM_DEFINITION.SYSTEM,
        sysfield: 'ai_telephone_voice_settings_ash',
    },
    {
        id: 'ai_telephone_voice_settings_ballad',
        usage: Constant.FORM_USAGE.TAG,
        name: {
            jp: {
                A: 'F',
                text: 'ballad (感情豊かで抒情的な声)',
            },
        },
        affiliationField: 'ai_telephone_voice_settings',
        type: '',
        structure: {
            isShowItemInTicket: true,
            no: 3,
        },
        viewForCustomer: {},
        definition: Constant.FORM_DEFINITION.SYSTEM,
        sysfield: 'ai_telephone_voice_settings_ballad',
    },
    {
        id: 'ai_telephone_voice_settings_coral',
        usage: Constant.FORM_USAGE.TAG,
        name: {
            jp: {
                A: 'F',
                text: 'coral (温かく親しみやすい声)',
            },
        },
        affiliationField: 'ai_telephone_voice_settings',
        type: '',
        structure: {
            isShowItemInTicket: true,
            no: 4,
        },
        viewForCustomer: {},
        definition: Constant.FORM_DEFINITION.SYSTEM,
        sysfield: 'ai_telephone_voice_settings_coral',
    },
    {
        id: 'ai_telephone_voice_settings_echo',
        usage: Constant.FORM_USAGE.TAG,
        name: {
            jp: {
                A: 'F',
                text: 'echo (反響のある幻想的な声)',
            },
        },
        affiliationField: 'ai_telephone_voice_settings',
        type: '',
        structure: {
            isShowItemInTicket: true,
            no: 5,
        },
        viewForCustomer: {},
        definition: Constant.FORM_DEFINITION.SYSTEM,
        sysfield: 'ai_telephone_voice_settings_echo',
    },
    {
        id: 'ai_telephone_voice_settings_sage',
        usage: Constant.FORM_USAGE.TAG,
        name: {
            jp: {
                A: 'F',
                text: 'sage (知的で穏やかな声)',
            },
        },
        affiliationField: 'ai_telephone_voice_settings',
        type: '',
        structure: {
            isShowItemInTicket: true,
            no: 6,
        },
        viewForCustomer: {},
        definition: Constant.FORM_DEFINITION.SYSTEM,
        sysfield: 'ai_telephone_voice_settings_sage',
    },
    {
        id: 'ai_telephone_voice_settings_shimmer',
        usage: Constant.FORM_USAGE.TAG,
        name: {
            jp: {
                A: 'F',
                text: 'shimmer (輝く軽やかな声)',
            },
        },
        affiliationField: 'ai_telephone_voice_settings',
        type: '',
        structure: {
            isShowItemInTicket: true,
            no: 7,
        },
        viewForCustomer: {},
        definition: Constant.FORM_DEFINITION.SYSTEM,
        sysfield: 'ai_telephone_voice_settings_shimmer',
    },
    {
        id: 'ai_telephone_voice_settings_verse',
        usage: Constant.FORM_USAGE.TAG,
        name: {
            jp: {
                A: 'F',
                text: 'verse (詩的でリズミカルな声)',
            },
        },
        affiliationField: 'ai_telephone_voice_settings',
        type: '',
        structure: {
            isShowItemInTicket: true,
            no: 8,
        },
        viewForCustomer: {},
        definition: Constant.FORM_DEFINITION.SYSTEM,
        sysfield: 'ai_telephone_voice_settings_verse',
    },
    {
        id: 'ai_telephone_voice_settings_marin',
        usage: Constant.FORM_USAGE.TAG,
        name: {
            jp: {
                A: 'F',
                text: 'marin (爽やかで透き通った海のような声)',
            },
        },
        affiliationField: 'ai_telephone_voice_settings',
        type: '',
        structure: {
            isShowItemInTicket: true,
            no: 9,
        },
        viewForCustomer: {},
        definition: Constant.FORM_DEFINITION.SYSTEM,
        sysfield: 'ai_telephone_voice_settings_marin',
    },
    {
        id: 'ai_telephone_voice_settings_cedar',
        usage: Constant.FORM_USAGE.TAG,
        name: {
            jp: {
                A: 'F',
                text: 'cedar (温かく木質で落ち着いた声)',
            },
        },
        affiliationField: 'ai_telephone_voice_settings',
        type: '',
        structure: {
            isShowItemInTicket: true,
            no: 10,
        },
        viewForCustomer: {},
        definition: Constant.FORM_DEFINITION.SYSTEM,
        sysfield: 'ai_telephone_voice_settings_cedar',
    },
    // AI Telephone Prompt fields end

    // KB Knowledge Format Fields
    // Field 1: シート名 (Sheet Name)
    {
        id: 'field_kb_sheet_name',
        sysfield: 'field_kb_sheet_name',
        usage: Constant.FORM_USAGE.FIELD,
        name: {
            jp: {
                A: 'F',
                text: 'シート名',
            },
        },
        type: Constant.FORM_TYPE.FIELD_TEXT,
        structure: {
            UI: Constant.FIELD_UI.TEXT,
            elasticSearch: '',
            required: true,
            minLength: 1,
            maxLength: 500
        },
        definition: Constant.FORM_DEFINITION.SYSTEM,
        noInFormKBKnowledge: 1,
    },

    // Field 2: sheet_id (Sheet ID)
    {
        id: 'field_kb_sheet_id',
        sysfield: 'field_kb_sheet_id',
        usage: Constant.FORM_USAGE.FIELD,
        name: {
            jp: {
                A: 'F',
                text: 'sheet_id',
            },
        },
        type: Constant.FORM_TYPE.FIELD_URL,
        structure: {
            UI: Constant.FIELD_UI.URL,
            elasticSearch: '',
            required: true,
        },
        definition: Constant.FORM_DEFINITION.SYSTEM,
        noInFormKBKnowledge: 2,
    },

    // Field 3: KB-XML (KB-XML Content)
    {
        id: 'field_kb_xml_content',
        sysfield: 'field_kb_xml_content',
        usage: Constant.FORM_USAGE.FIELD,
        name: {
            jp: {
                A: 'F',
                text: 'KB-XML',
            },
        },
        type: Constant.FORM_TYPE.FIELD_TEXT,
        structure: {
            UI: Constant.FIELD_UI.TEXT_AREA,
            elasticSearch: '',
            required: true
        },
        definition: Constant.FORM_DEFINITION.SYSTEM,
        noInFormKBKnowledge: 3,
    },

    // Field 4: KB-XMLタイムスタンプ (KB-XML Timestamp)
    {
        id: 'field_kb_xml_timestamp',
        sysfield: 'field_kb_xml_timestamp',
        usage: Constant.FORM_USAGE.FIELD,
        name: {
            jp: {
                A: 'F',
                text: 'KB-XMLタイムスタンプ',
            },
        },
        type: Constant.FORM_TYPE.FIELD_DATE,
        structure: {
            UI: Constant.FIELD_UI.DATE,
            dateFormat: Constant.SETTING_DATE_FIELD_FORMAT.YYYYMMDD_HHMM,
            elasticSearch: '',
            required: true
        },
        definition: Constant.FORM_DEFINITION.SYSTEM,
        noInFormKBKnowledge: 4,
    },
    // KB Knowledge Format Fields end
];

export default systemField;
